import { fetchIPERC } from "../http-common";

const postComboProceso = (
    data: any,
    constroller = new AbortController()
) => {
    return fetchIPERC.post(`Proceso/Combo`, data, {
        signal: constroller.signal,
    });
};

const ProcesoService = {
    postComboProceso
};

export default ProcesoService;